/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Status_Idp_DisabledInputs */



/**
* | output |
* | --- |
* | "Disabled by IdP" |
*
* @param {Members_Status_Idp_DisabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_status_idp_disabled = /** @type {((inputs?: Members_Status_Idp_DisabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Status_Idp_DisabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vom IdP deaktiviert")
	return /** @type {LocalizedString} */ ("Disabled by IdP")
});